/**
 * Lọc thời gian chọn chứng từ in
 */
export default {
  RefDate: 1, // ngày chứng từ
  PostedDate: 2, // Ngày hoạch toán
};
